export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13520.7d5c7fa1.jpg";